































import Vue from 'vue'

export default Vue.extend({
    data: () => ({
        isActive: false
    }),
    methods: {
        showInformativa() {
            this.isActive = true
        },
        colseInformativa() {
            this.isActive = false
        }
    }
})
